import React, { useRef, useState } from "react";
import { useMessage } from "../../../../../Components/MessageProvider/MessageProvider";
import axiosInstance from "../../../../../Components/axiosInstance/AxiosInstance";
import { Button, Flex, Input, Modal, Popconfirm, Spin } from "antd";
import { GoSearch } from "react-icons/go";
import { IoAdd } from "react-icons/io5";
import TextArea from "antd/es/input/TextArea";
import { AiOutlineDelete } from "react-icons/ai";
import { CiEdit } from "react-icons/ci";
import PrintAble from "./PrintAble";
import { LocalDiningOutlined } from "@mui/icons-material";

export default function Printykx({
  isModalOpen,
  setIsModalOpen,
  getData,
  id,
  selectedOne,
}) {
  let [loading, setLoading] = useState(false);
  let [loadingCustomer, setLoadingCustomer] = useState(false);
  let [data, setData] = useState(false);
  let [searchValue, setSearchValue] = useState("");
  const messageApi = useMessage();
  let [selected, setSelected] = useState([]);
  let searchDriverRef = useRef(null);
  let [customer, setCustomer] = useState([]);
  let [addNewDriverModal, setAddNewDriverModal] = useState(false);
  let [putDriverModal, setPutDriverModal] = useState(false);
  let [driverModal, setDriverModal] = useState(false);
  let [loadPutDriver, setLoadPutDriver] = useState(false);
  let [selectedDriver, setSelectedDriver] = useState(false);
  let [addNewDriverData, setAddNewDriverData] = useState({
    name: null,
    driver_name: null,
    auto_number: null,
    PNFL: null,
    INN: null,
    comment: null,
    auto: null,
    tara: null,
  });

  let [putDriverData, setPutDriverData] = useState({
    name: null,
    driver_name: null,
    auto_number: null,
    PNFL: null,
    INN: null,
    comment: null,
    auto: null,
    tara: null,
  });

  const handleSearch = async (value) => {
    try {
      setLoadingCustomer(true);

      let { data: info } = await axiosInstance.get(
        "/api/drivers/search?search=" + value
      );
      console.log(info);
      if (info.success) {
        setCustomer([...info.data]);
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
    } finally {
      setLoadingCustomer(false);
    }
  };
  const handleConnection = async (value) => {
    try {
      let { data: info } = await axiosInstance.post(
        "/api/chiqim-official/chirchiq/connection",
        {
          customer_id: value,
          id: [
            ...selected.map((el) => {
              return el.id;
            }),
          ],
        }
      );

      if (info.success) {
        setSelected([]);
        setCustomer([]);
        setData([
          ...data.map((el) => {
            return {
              ...el,
              selected: false,
            };
          }),
        ]);
      }
      console.log(info);
    } catch (error) {
      console.log(error);
    }
  };
  const handleAddDriver = async () => {
    try {
      let { data: info } = await axiosInstance.post("/api/drivers", {
        ...addNewDriverData,
      });

      if (info.success) {
        setAddNewDriverModal(false);
        setAddNewDriverData({
          name: null,
          driver_name: null,
          auto_number: null,
          PNFL: null,
          INN: null,
          comment: null,
          auto: null,
        });
      }
      console.log(info);
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
    }
  };
  const handlePutDriver = async () => {
    try {
      setLoadPutDriver(true);
      let { data: info } = await axiosInstance.put(
        "/api/drivers/" + putDriverData?.id,
        {
          ...putDriverData,
        }
      );

      if (info.success) {
        setPutDriverModal(false);
        setAddNewDriverData({
          name: null,
          driver_name: null,
          auto_number: null,
          PNFL: null,
          INN: null,
          comment: null,
          auto: null,
        });
      }
      console.log(info);
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
    } finally {
      setLoadPutDriver(false);
    }
  };
  const handleDelDriver = async (id) => {
    try {
      console.log(searchDriverRef);
      let { data: info } = await axiosInstance.delete("/api/drivers/" + id);
      if (info.success) {
        searchDriverRef.current.input.value = "";
        handleSearch("");
      }
      console.log(info);
    } catch (error) {
      console.log(error);
    }
  };
  // driverModal
  // if (driverModal) {
  //   return (

  //   );
  // }
  return (
    <div>
      {/* driver searching and connecting */}
      <Modal
        style={{ top: "10px" }}
        title="Xaydovchi Biriktirish"
        open={isModalOpen}
        //   loading={loadVagon}
        onOk={() => {
          setIsModalOpen(false);
        }}
        onCancel={() => {
          console.log("Modal closed via Cancel button or close icon.");
          setIsModalOpen(false);
        }}
        footer={[
          <Button
            key="back"
            onClick={() => {
              setIsModalOpen(false);
              setSelected([]);
              setCustomer([]);
            }}
            style={{ backgroundColor: "#f5222d", color: "#fff" }}
          >
            Yopish
          </Button>,
        ]}
      >
        <div className="flex flex-row items-center justify-center gap-2 m-auto">
          <Input
            type="text"
            placeholder="Birikuvchini yozing"
            className="w-[80%]"
            ref={searchDriverRef}
            onChange={(e) => {
              handleSearch(e.target.value);
              setSearchValue(e.target.value);
            }}
          />
          {/* <Button icon={<GoSearch />}></Button> */}
          <Button
            onClick={() => {
              setAddNewDriverModal(true);
            }}
            icon={<IoAdd />}
          ></Button>
        </div>
        <div className="h-[400px] overflow-auto">
          {loadingCustomer ? (
            <div className="flex flex-row items-center justify-center pt-[60px]">
              <Spin />
            </div>
          ) : null}
          {customer.length == 0 && !loadingCustomer ? (
            <div className="flex flex-row items-center justify-center pt-[60px]">
              <h2>Not found</h2>
            </div>
          ) : null}

          {customer.map((el) => {
            return (
              <article className="flex items-start space-x-6 p-1 rounded mt-3 hover:cursor-pointer hover:bg-[#94a3b836]">
                <div className="min-w-0 relative flex-auto">
                  <Popconfirm
                    title="Biriktirish!"
                    description={
                      `'${el.name}'` +
                      "ni " +
                      id +
                      " ga biriktirishga aminmisiz?"
                    }
                    onConfirm={() => {
                      setIsModalOpen(false);
                      setDriverModal(true);
                      handleConnection(el.id);
                      setSelectedDriver(el);
                    }}
                    onCancel={() => {
                      setSelectedDriver(null);
                    }}
                    okText="Yes"
                    cancelText="No"
                  >
                    <h2 className="font-semibold text-slate-900 truncate pr-20 text-[14px]">
                      {el?.name} -- {el?.INN}
                    </h2>
                    <dl className=" mb-0 flex flex-wrap text-sm leading-6 font-medium">
                      <div>
                        <dd className="text-[14px]">{el.auto_number}</dd>
                        <dd className="text-[14px]">{el.auto}</dd>
                        <dd className="text-[14px]">{el.driver_name}</dd>
                      </div>
                      <div>
                        <dt className="sr-only">Rating</dt>
                        <dd className="text-[14px] px-1.5 ring-1 ring-slate-200 rounded">
                          {el.INN}
                        </dd>
                      </div>
                      <div className="ml-2">
                        <dt className="sr-only">Year</dt>
                        <dd className="text-[14px]">{el.PNFL}</dd>
                      </div>
                    </dl>
                  </Popconfirm>
                  <div className="ml-2 border-t-[1px] pl-2 border-[#bfbfbf] flex flex-row justify-between ">
                    <div>
                      <dd className="sr-only">Year</dd>
                      <dd className="text-[14px]">{el.written_by}</dd>
                      <dd className="text-[14px]">{el.driver_name}</dd>
                    </div>
                    <div className="ml-2">
                      <Button
                        onClick={() => {
                          handleDelDriver(el?.id);
                        }}
                        icon={<AiOutlineDelete />}
                      ></Button>
                      <Button
                        onClick={() => {
                          setPutDriverData({
                            name: el?.name,
                            id: el?.id,
                            driver_name: el?.driver_name,
                            auto_number: el?.auto_number,
                            PNFL: el?.PNFL,
                            INN: el?.INN,
                            comment: el.comment,
                            auto: el.auto,
                          });
                          setPutDriverModal(true);
                        }}
                        icon={<CiEdit />}
                      ></Button>
                    </div>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </Modal>

      {driverModal ? (
        <PrintAble
          setSelectedDriver={setSelectedDriver}
          selectedDriver={selectedDriver}
          selectedOne={selectedOne}
          setDriverModal={setDriverModal}
          setIsModalOpen={setIsModalOpen}
        />
      ) : null}

      {/* adding new driver */}
      <Modal
        style={{ top: "10px" }}
        title="Xaydovchi Qo'shish"
        open={addNewDriverModal}
        //   loading={loadVagon}
        onOk={() => {
          setAddNewDriverModal(false);
        }}
        onCancel={() => {
          console.log("Modal closed via Cancel button or close icon.");
          setAddNewDriverModal(false);
        }}
        footer={[
          <Button
            key="back"
            onClick={() => {
              handleAddDriver();
              // setAddNewDriverModal(false);
            }}
            // style={{ backgroundColor: "#f5222d", color: "#fff" }}
          >
            Saqlash
          </Button>,
        ]}
      >
        <div className="h-[400px] overflow-auto ">
          <div className="flex flex-col items-center justify-center gap-4 m-auto">
            <div className="w-[100%]">
              <label className="text-[16px] w-[100%] text-left">
                Tashuvchi
              </label>
              <Input
                type="text"
                placeholder="Tashkilot nomi"
                className="w-[90%]"
                size="large"
                value={addNewDriverData.name}
                onChange={(e) => {
                  // handleSearch(e.target.value);
                  setAddNewDriverData({
                    ...addNewDriverData,
                    name: e.target.value,
                  });
                }}
              />
            </div>
            <div className="w-[100%]">
              <label className="text-[16px] w-[100%] text-left">
                Tashuvchi INN
              </label>
              <Input
                type="text"
                placeholder="Tashkilot INNsi"
                className="w-[90%]"
                size="large"
                value={addNewDriverData.INN}
                onChange={(e) => {
                  // handleSearch(e.target.value);
                  setAddNewDriverData({
                    ...addNewDriverData,
                    INN: e.target.value,
                  });
                }}
              />
            </div>
            <div className="w-[100%]">
              <label className="text-[16px] w-[100%] text-left">
                Xaydovchi ismi
              </label>
              <Input
                type="text"
                placeholder="Xaydovchi ismi"
                className="w-[90%]"
                size="large"
                value={addNewDriverData.driver_name}
                onChange={(e) => {
                  // handleSearch(e.target.value);
                  setAddNewDriverData({
                    ...addNewDriverData,
                    driver_name: e.target.value,
                  });
                }}
              />
            </div>
            <div className="w-[100%]">
              <label className="text-[16px] w-[100%] text-left">
                Auto tarasi
              </label>
              <Input
                type="text"
                placeholder="Xaydovchi ismi"
                className="w-[90%]"
                size="large"
                value={addNewDriverData.tara}
                onChange={(e) => {
                  // handleSearch(e.target.value);
                  setAddNewDriverData({
                    ...addNewDriverData,
                    tara: e.target.value,
                  });
                }}
              />
            </div>
            <div className="w-[100%]">
              <label className="text-[16px] w-[100%] text-left">
                Auto raqam
              </label>
              <Input
                type="text"
                placeholder="Auto raqam"
                className="w-[90%]"
                size="large"
                value={addNewDriverData.auto_number}
                onChange={(e) => {
                  setAddNewDriverData({
                    ...addNewDriverData,
                    auto_number: e.target.value,
                  });
                }}
              />
            </div>
            <div className="w-[100%]">
              <label className="text-[16px] w-[100%] text-left">
                PNFL raqami
              </label>
              <Input
                type="text"
                placeholder="PNFL raqami"
                className="w-[90%]"
                size="large"
                value={addNewDriverData.PNFL}
                onChange={(e) => {
                  setAddNewDriverData({
                    ...addNewDriverData,
                    PNFL: e.target.value,
                  });
                }}
              />
            </div>
            <div className="w-[100%]">
              <label className="text-[16px] w-[100%] text-left">
                Automabil nomi
              </label>
              <Input
                type="text"
                placeholder="Automabil nomi"
                className="w-[90%]"
                size="large"
                value={addNewDriverData.auto}
                onChange={(e) => {
                  setAddNewDriverData({
                    ...addNewDriverData,
                    auto: e.target.value,
                  });
                }}
              />
            </div>
            <div className="w-[100%]">
              <label className="block text-[16px] w-[100%] text-left">
                Izoh
              </label>
              <TextArea
                type="text"
                placeholder="Izoh yozing"
                className="w-[90%]"
                size="large"
                value={addNewDriverData.comment}
                onChange={(e) => {
                  setAddNewDriverData({
                    ...addNewDriverData,
                    comment: e.target.value,
                  });
                }}
              />
            </div>
          </div>
        </div>
      </Modal>

      {/* editting driver */}
      <Modal
        style={{ top: "10px" }}
        title="Xaydovchi Qo'shish"
        open={putDriverModal}
        //   loading={loadVagon}
        onOk={() => {
          setPutDriverModal(false);
        }}
        onCancel={() => {
          console.log("Modal closed via Cancel button or close icon.");
          setPutDriverModal(false);
        }}
        footer={[
          <Button
            key="back"
            onClick={() => {
              handlePutDriver();

              handleSearch(searchValue);
            }}
            // style={{ backgroundColor: "#f5222d", color: "#fff" }}
          >
            {!loadPutDriver ? "O'zgartirish" : "Yuklanmoqda "}
            {loadPutDriver ? (
              <Spin size="small" spinning={loadPutDriver} />
            ) : null}
          </Button>,
        ]}
      >
        <Flex gap="middle" vertical>
          <div className="h-[400px] overflow-auto ">
            <div className="flex flex-col items-center justify-center gap-4 m-auto">
              <div className="w-[100%]">
                <label className="text-[16px] w-[100%] text-left">
                  Tashuvchi
                </label>
                <Input
                  type="text"
                  placeholder="Tashkilot nomi"
                  className="w-[90%]"
                  size="large"
                  value={putDriverData.name}
                  onChange={(e) => {
                    // handleSearch(e.target.value);
                    setPutDriverData({
                      ...putDriverData,
                      name: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="w-[100%]">
                <label className="text-[16px] w-[100%] text-left">
                  Tashuvchi INN
                </label>
                <Input
                  type="text"
                  placeholder="Tashkilot INNsi"
                  className="w-[90%]"
                  size="large"
                  value={putDriverData.INN}
                  onChange={(e) => {
                    // handleSearch(e.target.value);
                    setPutDriverData({
                      ...putDriverData,
                      INN: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="w-[100%]">
                <label className="text-[16px] w-[100%] text-left">
                  Xaydovchi ismi
                </label>
                <Input
                  type="text"
                  placeholder="Xaydovchi ismi"
                  className="w-[90%]"
                  size="large"
                  value={putDriverData.driver_name}
                  onChange={(e) => {
                    // handleSearch(e.target.value);
                    setPutDriverData({
                      ...putDriverData,
                      driver_name: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="w-[100%]">
                <label className="text-[16px] w-[100%] text-left">
                  Auto tarasi
                </label>
                <Input
                  type="text"
                  placeholder="Xaydovchi ismi"
                  className="w-[90%]"
                  size="large"
                  value={putDriverData.tara}
                  onChange={(e) => {
                    // handleSearch(e.target.value);
                    setPutDriverData({
                      ...putDriverData,
                      tara: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="w-[100%]">
                <label className="text-[16px] w-[100%] text-left">
                  Auto raqam
                </label>
                <Input
                  type="text"
                  placeholder="Auto raqam"
                  className="w-[90%]"
                  size="large"
                  value={putDriverData.auto_number}
                  onChange={(e) => {
                    setPutDriverData({
                      ...putDriverData,
                      auto_number: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="w-[100%]">
                <label className="text-[16px] w-[100%] text-left">
                  PNFL raqami
                </label>
                <Input
                  type="text"
                  placeholder="PNFL raqami"
                  className="w-[90%]"
                  size="large"
                  value={putDriverData.PNFL}
                  onChange={(e) => {
                    setPutDriverData({
                      ...putDriverData,
                      PNFL: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="w-[100%]">
                <label className="text-[16px] w-[100%] text-left">
                  Automabil nomi
                </label>
                <Input
                  type="text"
                  placeholder="Automabil nomi"
                  className="w-[90%]"
                  size="large"
                  value={putDriverData.auto}
                  onChange={(e) => {
                    setPutDriverData({
                      ...putDriverData,
                      auto: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="w-[100%]">
                <label className="block text-[16px] w-[100%] text-left">
                  Izoh
                </label>
                <TextArea
                  type="text"
                  placeholder="Izoh yozing"
                  className="w-[90%]"
                  size="large"
                  value={putDriverData.comment}
                  onChange={(e) => {
                    setPutDriverData({
                      ...putDriverData,
                      comment: e.target.value,
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </Flex>
      </Modal>
    </div>
  );
}
